import React from "react";
import { Typography } from "@mui/material";
export default () => <Typography variant="h5">Procurement Module</Typography>;
